import { IconV2 } from "@deliverr/ui";
import React, { FC } from "react";

interface NavToggleProps {
  expanded: Boolean;
}

export const NavToggle: FC<NavToggleProps> = ({ expanded }) =>
  expanded ? <IconV2 type="angle-up" /> : <IconV2 type="angle-down" />;
